export default function Footer() {
  return (
    <div className='footer'>
      <p>Mäntylä</p>  
    </div>
  )
}
